/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbRespRefineMenu_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly pageType: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespAppliedFilters_itemSearch" | "SbSharedRefineMenuFilters_itemSearch" | "SbSharedRefineMenuDisplayPrefsSelect_itemSearch" | "SbSharedRefineMenuSearchWithin_itemSearch">;
    readonly " $refType": "SbRespRefineMenu_itemSearch";
};
export type SbRespRefineMenu_itemSearch$data = SbRespRefineMenu_itemSearch;
export type SbRespRefineMenu_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenu_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenu_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topCategoryL1",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuSearchWithin_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '34472aac3061321392d7e7456a12998a';
export default node;
